const IMAGES = {
  homePageGuide: new URL('./homePageGuide.jpg', import.meta.url).href,
};

export default IMAGES;
